import React, { useEffect, useState } from 'react';
import { Box, Typography, Stack, FormControl, Select, MenuItem } from '@mui/material';
import { fetchDeviceStats } from '../../api/analyticsApi';
import { Monitor, Smartphone, Tablet } from 'lucide-react';

const DeviceStats = () => {
  const [devices, setDevices] = useState([]);
  const [period, setPeriod] = useState('7d');

  useEffect(() => {
    const loadDevices = async () => {
      const user = JSON.parse(localStorage.getItem("user"));
      const data = await fetchDeviceStats(user?.propertyId?.id, period);
      console.log("📊 DeviceStats data:", data);
      setDevices(data);
    };

    loadDevices();
    const interval = setInterval(loadDevices, 10000);
    return () => clearInterval(interval);
  }, [period]);

  const maxCount = Math.max(...devices.map(d => d.count), 1);
  const sortedDevices = [...devices].sort((a, b) => b.count - a.count);

  return (
    <Box bgcolor="white" p={2} borderRadius={2} boxShadow={1} minHeight={390}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
        <Typography variant="subtitle2" color="textSecondary">DEVICES</Typography>
        <FormControl size="small">
          <Select
            value={period}
            onChange={(e) => setPeriod(e.target.value)}
            variant="standard"
            disableUnderline
          >
            <MenuItem value="7d">Last 7 days</MenuItem>
            <MenuItem value="30d">Last 30 days</MenuItem>
            <MenuItem value="60d">Last 60 days</MenuItem>
          </Select>
        </FormControl>
      </Box>
      <Stack spacing={1.2}>
        {sortedDevices.map((d, idx) => {
          // percentChange logic, color, and direction
          const percent = d.percentChange || 0;
          const color = percent > 0 ? 'success.main' : percent < 0 ? 'error.main' : 'text.secondary';
          const direction = percent > 0 ? '▲' : percent < 0 ? '▼' : '';
          return (
            <Box key={idx} py={0.18}>
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Box display="flex" alignItems="center" gap={1} minHeight={28}>
                  <Box display="flex" alignItems="center" justifyContent="center" width={20}>
                    {d.device === 'desktop' && <Monitor size={16} />}
                    {d.device === 'mobile' && <Smartphone size={16} />}
                    {d.device === 'tablet' && <Tablet size={16} />}
                  </Box>
                  <Typography noWrap fontSize="0.95rem">{d.device}</Typography>
                </Box>
                <Box display="flex" alignItems="center" gap={1}>
                  <Typography fontWeight="normal" fontSize="0.9rem">{d.count}</Typography>
                  <Typography variant="caption" color={color}>
                    {direction} {Math.abs(percent)}%
                  </Typography>
                </Box>
              </Box>
              <Box
                height={6}
                mt={0.5}
                borderRadius={5}
                bgcolor="#eee"
                position="relative"
              >
                <Box
                  bgcolor="#1976d2"
                  height="100%"
                  width={`${(d.count / maxCount) * 100}%`}
                  borderRadius={5}
                  sx={{ transition: 'width 0.6s ease-in-out' }}
                />
              </Box>
            </Box>
          );
        })}
      </Stack>
    </Box>
  );
};

export default DeviceStats;
